module.exports = __webpack_public_path__ + "img/2.d8e269d7.jpg";